export default "<h1>Type3Number list</h1>\n<spec-app-type3-number-table [clickHandler]=\"createClickHandler()\"></spec-app-type3-number-table>";